<div class="om-fade" #OmFadeElement>
  <div
    class="om-fade-content"
    [ngClass]="direction"
    [class.show]="inViewport"
    [style.transitionDuration]="transitionDuration"
    [style.transitionTimingFunction]="transitionFunction"
  >
    <ng-content></ng-content>
  </div>
</div>
